interface DyPersonalizedContentProps {
  contentId: string
}
export function DyPersonalizedContent({
  contentId,
}: DyPersonalizedContentProps) {
  if (!contentId) {
    return null
  }

  return (
    <div
      className="w-full restructure-maxTablet:flex restructure-maxTablet:items-center restructure-maxTablet:justify-center max-w-[92vw] md:max-w-[1280px] px-4 restructure-tablet:px-5 restructure-small-desktop:px-0 mx-auto my-[40px] restructure-tablet:my-[56px] restructure-small-desktop:my-[80px] overflow-hidden"
      id={contentId}
    />
  )
}
